import * as React from 'react';

import moment from 'moment-timezone';

import { StarRating } from 'components/StarRating/StarRating';

import { useBusiness } from 'hooks/business/useBusiness';
import { useReview } from 'hooks/review/useReview';

import { TReview } from 'types/review';

import s from './Review.module.css';

const MAX_MESSAGE_LENGTH = 800;

type TProps = {
  review: TReview;
};

export const Review = ({ review }: TProps) => {
  const { isMultiUser } = useBusiness();

  const {
    message,
    rating,
    user_name,
    created_at,
    reviewer_name,
    isFullMessageDisplayed,
    showFullMessage,
  } = useReview({ review, maxMessageLength: MAX_MESSAGE_LENGTH });

  return (
    <div className={s.review}>
      <div className={s.ratingItemLine}>
        <StarRating
          value={rating}
          fillColor="#FACE15"
          emptyColor="var(--accent-secondary)"
        />
        <span className={s.servicesName}>
          {isMultiUser ? `with ${user_name}` : null}
        </span>
      </div>
      {message ? (
        <div>
          <div>{message}</div>
          {!isFullMessageDisplayed && (
            <button
              type="button"
              className={s.moreButton}
              onClick={showFullMessage}
            >
              Show More
            </button>
          )}
        </div>
      ) : null}
      <div className={s.reviewName}>
        {moment(created_at).format('MM.DD.YYYY')} &#183; {reviewer_name}
      </div>
    </div>
  );
};
